/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Reliability_ProofInputs */

const fr_legal_reliability_proof = /** @type {(inputs: Legal_Reliability_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bus Tracker ne peut en aucun cas servir de preuve "légale" ou officielle (notamment devant un employeur ou toute autre autorité). L'exactitude des positions et des horaires n'est pas garantie et dépend des flux de données fournis par les opérateurs.`)
};

const en_legal_reliability_proof = /** @type {(inputs: Legal_Reliability_ProofInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bus Tracker cannot under any circumstances be used as "legal" or official evidence (including before an employer or any other authority). The accuracy of positions and schedules is not guaranteed and depends on the data feeds provided by operators.`)
};

/**
* | output |
* | --- |
* | "Bus Tracker cannot under any circumstances be used as \"legal\" or official evidence (including before an employer or any other authority). The accuracy of pos..." |
*
* @param {Legal_Reliability_ProofInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_reliability_proof = /** @type {((inputs?: Legal_Reliability_ProofInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Reliability_ProofInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_legal_reliability_proof(inputs)
	return en_legal_reliability_proof(inputs)
});